
export default function CooperationTypesSection() {
  const cooperationTypes = [
    {
      icon: "ri-shopping-cart-2-line",
      title: "电商合作伙伴",
      subtitle: "线上渠道优先",
      features: [
        "提供爆款产品资源",
        "专业运营指导",
        "高达35%佣金比例",
        "24小时快速发货",
        "完善售后支持"
      ],
      investment: "0",
      return: "月利润20-80万",
      highlight: true
    },
    {
      icon: "ri-map-pin-2-line",
      title: "区域代理商",
      subtitle: "独享区域经营权",
      features: [
        "独家区域代理权",
        "品牌授权支持",
        "营销物料支持",
        "技术培训指导",
        "区域保护政策"
      ],
      investment: "20-50万",
      return: "年利润30-100万",
      highlight: false
    },
    {
      icon: "ri-store-2-line",
      title: "零售合作商",
      subtitle: "灵活合作模式",
      features: [
        "低门槛准入",
        "灵活进货政策",
        "营销支持",
        "产品培训",
        "快速回款"
      ],
      investment: "1-10万",
      return: "月利润5000-3万",
      highlight: false
    },
    {
      icon: "ri-home-2-line",
      title: "品牌加盟店",
      subtitle: "完整品牌授权",
      features: [
        "统一店面设计",
        "完整品牌授权",
        "营运管理支持",
        "区域保护政策",
        "持续培训体系"
      ],
      investment: "10-30万",
      return: "年利润20-60万",
      highlight: false
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            四种合作模式
          </h2>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mb-6"></div>
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            多样化合作模式，满足不同投资需求和经营方式，共创共赢
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {cooperationTypes.map((type, index) => (
            <div 
              key={index} 
              className={`relative bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 ${
                type.highlight ? 'ring-2 ring-[#cc9966] ring-offset-2' : ''
              }`}
            >
              {type.highlight && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <span className="bg-[#cc9966] text-white px-4 py-1 rounded-full text-xs font-semibold">
                    推荐
                  </span>
                </div>
              )}
              
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-[#cc9966] to-[#b8865a] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${type.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-2">{type.title}</h3>
                <p className="text-xs sm:text-sm text-[#cc9966] font-medium">{type.subtitle}</p>
              </div>

              <div className="space-y-3 mb-6">
                {type.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center space-x-2">
                    <i className="ri-check-line text-[#cc9966] text-sm flex-shrink-0"></i>
                    <span className="text-xs sm:text-sm text-gray-600">{feature}</span>
                  </div>
                ))}
              </div>

              <div className="bg-white rounded-lg p-4 mb-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs sm:text-sm text-gray-600">投资金额</span>
                  <span className="text-xs sm:text-sm font-semibold text-[#663333]">{type.investment}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-600">预期收益</span>
                  <span className="text-xs sm:text-sm font-semibold text-[#cc9966]">{type.return}</span>
                </div>
              </div>

              <button className="w-full bg-[#663333] text-white py-3 rounded-lg font-semibold text-xs sm:text-sm hover:bg-[#552222] transition-colors duration-300 whitespace-nowrap cursor-pointer">
                了解详情
              </button>
            </div>
          ))}
        </div>

        {/* 合作流程 */}
        <div className="mt-20">
          <h3 className="text-xl sm:text-2xl font-bold text-[#663333] text-center mb-12">
            合作流程
          </h3>
          <div className="flex flex-col md:flex-row justify-center items-center md:items-start space-y-6 md:space-y-0 md:space-x-8">
            <div className="flex flex-col items-center text-center max-w-xs">
              <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center mb-4">
                <span className="text-white font-bold text-sm">1</span>
              </div>
              <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">提交申请</h4>
              <p className="text-xs sm:text-sm text-gray-600">填写合作申请表，提交相关资料</p>
            </div>
            
            <div className="hidden md:block w-8 h-px bg-[#cc9966] mt-6"></div>
            
            <div className="flex flex-col items-center text-center max-w-xs">
              <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center mb-4">
                <span className="text-white font-bold text-sm">2</span>
              </div>
              <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">资质审核</h4>
              <p className="text-xs sm:text-sm text-gray-600">专业团队评估，3-5个工作日完成</p>
            </div>
            
            <div className="hidden md:block w-8 h-px bg-[#cc9966] mt-6"></div>
            
            <div className="flex flex-col items-center text-center max-w-xs">
              <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center mb-4">
                <span className="text-white font-bold text-sm">3</span>
              </div>
              <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">签署合同</h4>
              <p className="text-xs sm:text-sm text-gray-600">双方确认合作细节，签署合作协议</p>
            </div>
            
            <div className="hidden md:block w-8 h-px bg-[#cc9966] mt-6"></div>
            
            <div className="flex flex-col items-center text-center max-w-xs">
              <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center mb-4">
                <span className="text-white font-bold text-sm">4</span>
              </div>
              <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">正式合作</h4>
              <p className="text-xs sm:text-sm text-gray-600">享受全方位支持，开始盈利之旅</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
